import type { AccessibleBoard } from '@/entities/collab';

/**
 * "My boards" are boards of the viewer's PERSONAL workspace. Ownership alone does not decide it:
 * a board someone owns inside a team workspace belongs with the team boards.
 */
export function isPersonalBoard(board: AccessibleBoard): boolean {
  return board.workspace_type === 'personal';
}
